import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import ChecklistDownload from "./ChecklistDownload";
import "./Blog.css";
import "./BlogPostSafetyManager.css";
import "./BlogPostForeman.css";

function BlogPostDailyRecord() {
  const records = [
    {
      num: "1",
      title: "TBM 기록",
      time: "매일 아침, 2분",
      must: ["참석자 명단 (사진 or 체크)", "오늘 위험 공지 내용 한 줄", "특이사항 (없으면 '없음')"],
      why: "TBM을 했다는 증거입니다. 이게 없으면 안 한 것과 같습니다.",
    },
    {
      num: "2",
      title: "위험 발견 즉시 기록",
      time: "발견한 그 순간",
      must: ["현장 사진 1장", "위치와 위험 내용 한 줄", "조치 결과 (완료 or 예정일)"],
      why: "위험을 알고 있었다는 증거이자, 조치했다는 증거입니다. 둘 다 필요합니다.",
    },
    {
      num: "3",
      title: "작업 종료 확인",
      time: "퇴근 전, 1분",
      must: ["오늘 작업 완료 여부", "내일 이어지는 작업 특이사항"],
      why: "짧아도 됩니다. 있는 것과 없는 것의 차이가 큽니다.",
    },
  ];

  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>현장 운영</span>
          </div>
          <h1>오늘 현장에서<br />꼭 남겨야 할 기록 딱 3가지</h1>
          <div className="blog-post-meta">
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장 운영</span>
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장소장</span>
            <span>2026.06.05</span>
            <span>읽기 2분</span>
          </div>
        </div>

        <article className="sm-article">

          <p>현장소장이 매일 남겨야 하는 서류를 다 나열하면 끝이 없습니다.</p>
          <p>그러니 이것만 묻겠습니다.</p>

          <div className="fm-big-question">
            오늘 하루, 최소한 이 3가지는 있습니까?
          </div>

          <div className="fm-record-cards">
            {records.map((r) => (
              <div className="fm-record-card" key={r.num}>
                <div className="fm-record-header">
                  <div className="fm-record-num">{r.num}</div>
                  <div className="fm-record-title">{r.title}</div>
                  <div className="fm-record-time">{r.time}</div>
                </div>
                <div className="fm-record-body">
                  <ul className="fm-must-list">
                    {r.must.map((item, i) => (
                      <li key={i}>
                        <span className="fm-must-dot">✓</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="fm-record-why">
                    <span className="fm-why-label">왜 필요한가</span>
                    {r.why}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <h2 className="sm-h2">이 3가지로 충분한 이유</h2>

          <p>완벽한 서류보다 <strong>매일 있는 서류</strong>가 낫습니다.</p>
          <p>감사관이나 조사관이 보는 건 서류의 두께가 아니라 <strong>연속성</strong>입니다. 오늘도 있고, 어제도 있고, 지난달에도 있는 기록.</p>
          <p>3가지만 매일 하면 그게 쌓입니다.</p>

          <div className="fm-tip-box">
            <div className="fm-tip-title">💡 현장에서 바로 하는 방법</div>
            <p>사무실 올라가지 말고, 현장에서 스마트폰으로 바로 남기세요. TBM 끝나고 인원 흩어지기 전에 30초. 위험 발견하면 그 자리에서 사진 한 장. 퇴근 전 차 타기 전 1분.</p>
            <p>이 3번이 습관이 되면, 퇴근 후 서류 작업이 없어집니다.</p>
          </div>

          <div className="sm-cta">
            <div className="sm-cta-question">현장에서 바로 기록하고 싶으신가요?</div>
            <p>현장통으로 TBM, 위험 발견, 작업 확인을<br />스마트폰으로 현장에서 바로 기록하세요.</p>
            <div className="sm-cta-buttons">
              <ChecklistDownload
                checklistTitle="현장 일일 안전기록 체크리스트"
                pdf="/checklists/daily-safety-record-checklist.pdf"
                fileName="현장통_현장일일안전기록_체크리스트.pdf"
                className="sm-cta-btn primary"
                label="무료 체크리스트 받기 →"
              />
              <a href="/#contact" className="sm-cta-btn secondary">
                무료체험 문의하기
              </a>
            </div>
          </div>

          <div className="blog-tags">
            {["#현장소장", "#건설현장기록", "#TBM", "#안전관리", "#현장통", "#건설안전", "#안전서류"].map(tag => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          <div className="blog-related">
            <h3>다음으로 읽으면 좋은 글</h3>
            <div className="related-grid">
              <Link to="/blog/tbm-no-record" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">TBM 매일 하는데 왜 기록이 없나 — 현장소장의 현실</div>
              </Link>
              <Link to="/blog/risk-assessment-5steps" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">이번 달 위험성평가, 빠진 항목 없이 끝내는 5단계</div>
              </Link>
              <Link to="/blog/serious-accident-law" className="related-card">
                <div className="related-card-tag">법규 가이드</div>
                <div className="related-card-title">중대재해처벌법 건설사 실무 대응 가이드</div>
              </Link>
            </div>
          </div>

        </article>

        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostDailyRecord;
